import { SVGS } from '~/assets/assetsPath';
import config from '~/config';

export const navPopoverProfile = [
    {
        id: 1,
        icon: SVGS.IconPeople,
        iconActive: SVGS.IconPeopleSelected,
        text: 'Personal information',
        path: config.routes.profile,
    },
    {
        id: 2,
        icon: SVGS.IconWallet,
        iconActive: SVGS.IconWalletSelected,
        text: 'My wallet',
        path: config.routes.topUp,
    },
    {
        id: 3,
        icon: SVGS.IconCard,
        iconActive: SVGS.IconCardSelected,
        text: 'My card',
        path: config.routes.card,
    },
    {
        id: 4,
        icon: SVGS.IconBill,
        iconActive: SVGS.IconBillSelected,
        text: 'Order',
        path: config.routes.orders,
    },
    {
        id: 5,
        icon: SVGS.IconSchedule,
        iconActive: SVGS.IconScheduleSelected,
        text: 'Schedule history',
        path: config.routes.historyBooking,
    },
    {
        id: 6,
        icon: SVGS.IconDownLineCollab,
        iconActive: SVGS.IconDownLineCollabSelected,
        text: 'Collaborator',
        path: config.routes.downLineCollab,
        children: [],
    },
    {
        id: 7,
        icon: SVGS.IconQRCode,
        iconActive: SVGS.IconQRCodeSelected,
        text: 'my QR',
        path: config.routes.shareCollab,
        children: [],
    },
    {
        id: 8,
        icon: SVGS.IconItemLogOut,
        iconActive: SVGS.IconFavorite,
        text: 'Sign out',
        path: '#',
    },
];
